import { useRef,useEffect } from 'react';
import { useResetRecoilState } from 'recoil';
import { namespaceState,selectedTaskState,newTaskConfig } from '../../recoil/atoms';
import logoMotion from '../../assets/logo_motion.webm';
import styles from './style.module.css';
import useApi from '../../services/useApi';
import uuidV4 from '../../utils/uuidV4';
import NaviButton from '../../compoenets/NaviButton';

export default function Landing() {
  const landingLogo=useRef(null);
  // const resetNsState=useResetRecoilState(namespaceState);
  // const resetTaskState=useResetRecoilState(selectedTaskState);
  // const resetTaskConfig=useResetRecoilState(newTaskConfig);

  useEffect(() => {
    if(landingLogo.current.played.length === 0 ) landingLogo.current.play();
    // resetNsState();
    // resetTaskState();
    // resetTaskConfig();

    const timer = setInterval(() => {
      let landingLogoPlay=landingLogo.current.play();
      if (landingLogoPlay !== undefined) { landingLogoPlay.then((_) => {}).catch((error) => {}); }
    }, 8000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  const handleSignIn=()=>{
    useApi.get('backboard/user/key/1').then((res)=>{
      if (res.status === 200) {
        let resData = res.data;
        let redirectUrl = resData.loginUrl +
          "?client_id=" + resData.clientId +
          "&redirect_uri=" + resData.redirectUrl +
          "&response_type=" + resData.responseType +
          "&scope=" + resData.scope +
          "&nonce=" + uuidV4();
        window.location.href = redirectUrl 
      } else {
          alert('SSO 로그인 실패, 관리자에게 연락바랍니다.')
      }
    })
    .catch(async (err) => {
      console.log(err)
      alert('서버연결 실패, 관리자에게 연락바랍니다.')
    })
  }

  return (
      <div className={styles["wrap"]}>
        <div className={styles["logo"]}>
          <video 
          ref={landingLogo} muted className={styles["logo-motion"]}>
            <source src={logoMotion} type="video/webm"/>
          </video>
        </div>
        <div className={styles["title"]}>
          <p className={styles["title-main"]}>
            UT Dashboard
          </p>
          <button className={`${styles["btn"]} ${styles["btn-signIn"]}`} onClick={handleSignIn}>Sign In</button>
        </div>
      </div>
  );
}